"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diminishEnrichedAddPcbNodesCommand = diminishEnrichedAddPcbNodesCommand;
exports.diminishEnrichedUpdatePcbNodesCommand = diminishEnrichedUpdatePcbNodesCommand;
const lodash_1 = require("lodash");
const common_1 = require("../../document/command/common");
const mapBakedNodeToUnbakedNode = (node) => {
    const unbakedNode = { ...node };
    delete unbakedNode.bakedRules;
    delete unbakedNode.flattenedRules;
    return unbakedNode;
};
function diminishEnrichedAddPcbNodesCommand(command) {
    return {
        type: common_1.CommandType.addPcbNodesCommand,
        nodes: Array.isArray(command.nodes)
            ? (0, lodash_1.chain)(command.nodes.map(mapBakedNodeToUnbakedNode)).keyBy("uid").value()
            : (0, lodash_1.mapValues)(command.nodes, mapBakedNodeToUnbakedNode),
    };
}
function diminishEnrichedUpdatePcbNodesCommand(command) {
    return {
        type: common_1.CommandType.updatePcbNodesCommand,
        nodes: Array.isArray(command.nodes)
            ? (0, lodash_1.chain)(command.nodes.map(mapBakedNodeToUnbakedNode)).keyBy("uid").value()
            : (0, lodash_1.mapValues)(command.nodes, mapBakedNodeToUnbakedNode),
    };
}
//# sourceMappingURL=diminisher.js.map